module.exports = __webpack_public_path__ + "img/3.eb04c444.jpg";